import { Logger } from '@datadog/browser-logs';
import { BatchLogTransport } from '@remento/logger/transport/utils/batch';
import { InternalLogMessage, LogLevel } from '@remento/logger/types';

export class BrowserDatadogLogTransport extends BatchLogTransport {
  constructor(private datadogLogger: Logger) {
    super(100);
  }

  async logBatch(logs: Array<[LogLevel, InternalLogMessage]>): Promise<void> {
    try {
      for (let i = 0; i < logs.length; i++) {
        // This is a tremendously inefficient way of consuming the queue but it's simple and interruptible
        const [_, payload] = logs[i];
        const { level, message, ts, ...metadata } = payload;
        switch (level) {
          case LogLevel.trace:
          case LogLevel.debug:
            this.datadogLogger.debug(message, metadata);
            break;
          case LogLevel.info:
            this.datadogLogger.info(message, metadata);
            break;
          case LogLevel.warn:
            this.datadogLogger.warn(message, metadata);
            break;
          case LogLevel.error:
            this.datadogLogger.error(message, metadata);
            break;
          default:
            this.datadogLogger.log(message, metadata);
        }
      }
    } catch (err) {
      console.error('DatadogLogTransport - Failure', err);
    }
  }
}
